import React, { useState, useEffect, useLayoutEffect} from 'react'
import axios from 'axios' 
// css
import './YourBodyAds.sass'
export default function YourBodyAds(){
  
      const adsDesktopURL = "https://servedbyadbutler.com/adserve/;ID=167752;size=728x90;setID=326784;type=json;click=CLICK_MACRO_PLACEHOLDER";
      const adsMobileURL = "https://servedbyadbutler.com/adserve/;ID=167752;size=234x60;setID=326785;type=json;click=CLICK_MACRO_PLACEHOLDER";
      const [adsApiURL, setURL] = useState()
      const [screenWidth, setScreenWidth] = useState(window.innerWidth)
      const showBob = true;
      const [adsData, setAdsData] = useState({
        status: "",
        placements: []
      })
      const [imageData, setImage] = useState({
        alt_text: "",
        image_url: "",
        redirect_url: ""
      });
      //get image data from digital adbulter
      useLayoutEffect(() => {
        function updateScreenWidth() {
          setScreenWidth(window.innerWidth)
          screenWidth > 570 ? setURL(adsDesktopURL) : setURL(adsMobileURL)
        }
        window.addEventListener('resize', updateScreenWidth)
        updateScreenWidth()   
    }, [ screenWidth ])
      
      useEffect(() =>{
        
          axios.get(adsApiURL)
          .then(response =>{
            setAdsData(
              {
                status: response.data.status,
                placements: response.data.placements
              })
          })
          .catch(error =>console.log(error))
        
      },[adsApiURL,screenWidth]);

      const imageTotalData = adsData.placements.placement_1;
      useEffect(()=>{
      if(imageTotalData!==undefined) {
        setImage({
          alt_text: imageTotalData.alt_text,
          image_url: imageTotalData.image_url,
          redirect_url: imageTotalData.redirect_url
        })}
      },[adsData, imageTotalData]);

      const imageClick = () =>{
        window.open(imageData.redirect_url, "_blank")
      }
      useEffect(() => {
        window.scrollTo(0,700)
      }, [])
      
     return(
      <div className = "GetCentreLayout">
          <div className="ASection">
            <div className="Desktop">
              { imageData && showBob &&
                <img alt={imageData.alt_text} src={imageData.image_url}  onClick={()=>imageClick()}/>
              }
            </div>
            <div className="Mobile">
              { imageData && showBob &&
                <img alt={imageData.alt_text} src={imageData.image_url}  onClick={()=>imageClick()}/>
              }
            </div>
        </div>
        </div>
      );
  
}      